import Icon from '../components/Icon.vue'

Icon.register({
  'ice-cream': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M368 160c26.5 0 48 21.5 48 48s-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48s21.5-48 48-48h0.9c-0.5-4.5-0.9-11.9-0.9-16.4 0-79.5 64.5-144 144-144s144 64.5 144 144c0 4.5-0.4 11.9-0.9 16.4h0.9zM195.4 493.7l-99.4-205.7h256l-99.4 205.7c-4.7 10.1-17.5 18.3-28.6 18.3s-24-8.2-28.6-18.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ice-cream.js
// module id = 1478
// module chunks = 0